import { useQuery } from '@apollo/client/react';
import { useAuth } from 'app/domains/auth/hooks/useAuth';
import { CompanyFeaturesProviderQueryDocument } from './query.gql';
import { useExcludedRoutes } from './useExcludedRoutes';
import { extractFeatures, extractFileSystemFeatures } from './utils';
export const useGetCompanyFeatures = (companyId) => {
    const { data: authData } = useAuth();
    const { authenticated, profile } = authData || {};
    const excludedRoute = useExcludedRoutes();
    const { verified } = profile || {};
    const skip = !companyId || !authenticated || !verified || excludedRoute;
    const { data, loading, error } = useQuery(CompanyFeaturesProviderQueryDocument, {
        variables: { companyId: companyId || '' },
        skip,
    });
    const { company, fileSystemCompanyFeatures = [] } = data || {};
    const { esigningFeatures = [], features = [], assistantFeatures = [], userFeatures = [], webApiFeatures = [], sharepointIntegrationFeatures = [], } = company || {};
    const companyFeatures = features !== null && features !== void 0 ? features : [];
    const transformedFeatures = [
        ...extractFeatures(companyFeatures),
        ...extractFeatures(esigningFeatures),
        ...extractFeatures(assistantFeatures),
        ...extractFeatures(userFeatures),
        ...extractFeatures(webApiFeatures),
        ...extractFeatures(sharepointIntegrationFeatures),
        ...extractFileSystemFeatures(fileSystemCompanyFeatures),
    ];
    return {
        loading,
        error,
        features: transformedFeatures,
    };
};
